<template>
<div class="h-vertical-content">
  <transition-group name="drag" class="h-vertical-body" :style="{background: bodyBackground}">
    <div class="list-item" :draggable="whetherDrag" @dragend="dragend()" @dragenter="dragenter($event, i)" @dragover="dragover($event, i)" @dragstart="dragstart(i)" v-for="item,i in list" :key="item.value" :style="{background: sIndex == i ?itemBackground:'#fff',height:sIndex == i && item.children?(item.children.length *60+58)+'px':'58px','font-weight':sIndex == i?'500':'300'}">
      <div class="list-item-superior" @click.stop="changeItem(item,i)">
        <slot name="header" :flag="sIndex==i"></slot>
        <div class="list-item-title text-overflow" :style="{color:sIndex == i?'#2B2F3F':'#848484',width: widthTitle,left: leftTitle}">{{item.label}}</div>
        <i v-if="iconRight && item.children" :class="iconElIcon?iconElIcon:''" class="list-item-arrow" :style="{transform: iconTurn && sIndex == i?'rotate(90deg)':'',display:clickShow ? (sIndex != i?'none':''):'',right: rightLogo}"></i>
        <div class="click-event-tag" :style="{display: clickTagFlag && sIndex == i?'':'none',background:clickTagColor}"></div>
      </div>
      <div class="list-item-lower" v-show="item.children && sIndex == i">
        <div class="list-item-lower-item" @click.stop="changeLowerItem(info,index)" v-for="info,index in item.children" :key="index" :style="{background:lIndex==index?'#F2F2F2':'#FFFFFF',color:lIndex==index?'#222222':'#848484'}">
          <div class="list-item-lower-item-header" v-if="info.lowerItemHeader">
            <i v-if="info.lowerIconLeft" :class="info.lowerIconElLeft?info.lowerIconElLeft:''" class="" :style="{transform: info.lowerIconLeftTurn && lIndex == index?'rotate(90deg)':''}"></i>
            <img v-if="info.lowerUrl" :src="info.lowerUrl">
          </div>
          <div class="text-overflow" :style="{width: info.lowerItemHeader ?'calc(100% - 68px)':'100%',paddingLeft: info.lowerItemHeader ?'':'40px'}">{{info.label}}</div>
          <i v-if="info.lowerIconRight" :class="info.iconElIconRight?info.iconElIconRight:''" class="list-item-lower-arrow" :style="{transform: info.lowerIconRightTurn && sIndex == i?'rotate(90deg)':'',right: info.lowerRightLogo}"></i>
        </div>
      </div>
    </div>
  </transition-group>
  </div>
</template>
<script>
/*
 * list：数据格式：
      [
        {
          label: '标题（必填）',
          value: '值',
          children: [
            { lable: '标题（必填）',
              value: '值',
              lowerItemHeader: boolean(是否有头部图标) 默认没有,
              lowerIconLeft: boolean(是否有头部图标) 默认没有,
              lowerIconElLeft: el-ui  icon的类名,
              lowerIconLeftTurn: boolean(是否旋转) 默认没有,
              lowerUrl: url(图标)
              lowerIconRight:  boolean(是否有图标) 默认没有,
              iconElIconRight: el-ui  icon的类名
              lowerIconRightTurn: boolean(是否旋转) 默认没有,
            }
          ] 
        }
      ]//若有其他字段也可添加进去
 * bodyBackground：背景颜色
 * clickShow: boolean(是否点击时显示) 默认false-一直显示,
 * itemBackground：选中时的模块的背景颜色
 * slot 左边支持插槽 点击状态通过绑定变量传递
 * widthTitle:标题宽度。默认67%，可传px或%
 * leftTitle: 标题left的大小 默认58px(若有header的slot则尽量跟其内部的最外层的div宽度保持一致)
 * iconRight: 是否显示右侧图标：boolean,默认false
 * iconElIcon: 一级 右侧el-UI的icon的类名
 * iconTurn: 一级 右侧 图标是否旋转，boolean,默认false
 * rightLogo: 右侧标识的距右宽度 默认12px、
 * clickTagFlag: boolean(是否点击时显示) 默认false 选中时是否显示右边的竖线
 * clickTagColor：选中时的右边竖线标识的背景颜色

 */
export default {
  props: {
    list: {
      type: Array,
    },
    bodyBackground: {
      type: String,
      default: '#fff',
    },
    clickTagFlag: {
      type: Boolean,
      default: false,
    },
    clickTagColor: {
      type: String,
      default: '#17A48B',
    },
    clickShow: {
      type: Boolean,
      default: false,
    },
    itemBackground: {
      type: String,
      default: '#F2F2F2',
    },
    widthTitle: {
      type: String,
      default: '65%',
    },
    leftTitle: {
      type: String,
      default: '58px',
    },
    iconElIcon: {
      type: String,
    },
    iconRight: {
      type: Boolean,
      default: false,
    },
    iconTurn: {
      type: Boolean,
      default: false,
    },
    rightLogo: {
      type: String,
      default: '12px',
    },
    // 2022-12-23 jws  是否可拖拽
    whetherDrag: {
      type: Boolean,
      default: false,
    },
    parentSIndex: {
      type: Number,
      default: 0,
    },
    parentLIndex: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      sIndex: 0,
      // sIndexBak: 0, //备份有被点击了的子属性的行的索引
      lIndex: -1,
      // lIndexBak: -1, //备份被点击的子属性的索引
    }
  },
  watch: {
    list: {
      handler(valueNew, valueOld) {
        this.sIndex = this.parentSIndex;
        this.lIndex = this.parentLIndex;
        // this.list
        // console.log('---------------list:', valueOld, valueNew)
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    // 2022-12-23 jws  是否可拖拽
    dragstart(index) {
      this.sIndex = index;
      this.$emit('click', this.sIndex, this.lIndex)
    },
    // 2022-12-23 jws  是否可拖拽
    dragenter(e, index) {
      e.preventDefault();
      // 避免源对象触发自身的dragenter事件
      if (this.sIndex !== index) {
        const source = this.list[this.sIndex];
        this.list.splice(this.sIndex, 1);
        this.list.splice(index, 0, source);
        // 排序变化后目标对象的索引变成源对象的索引
        this.sIndex = index;
      }
    },
    // 2022-12-23 jws  是否可拖拽
    dragover(e, index) {
      e.preventDefault();
    },
    changeItem(value, index) {
      console.log('value:', value)
      if (index == this.sIndex) {
        //若是多级情况则点击同一个选项就关闭，若是一级就什么也不做
        if (value.children) {
          this.sIndex = -1
        }
      } else {
        this.sIndex = index
        this.lIndex = -1
        this.$emit('click', this.sIndex, this.lIndex)
        // //当点击行与之前备份的行的索引位置一致时将备份的子属性的索引赋值给现在的子属性的索引变量
        // if (this.sIndexBak == index) {
        //   this.lIndex = this.lIndexBak
        // } else {
        //   this.lIndex = -1
        // }
        // //若没有子集children则点击第一级就返回信息
        // if (!value.children) {
        //   this.$emit('click', this.sIndex)
        // }
      }
    },
    changeLowerItem(value, index) {
      this.lIndex = index
      // this.lIndexBak = index //备份
      //只有当点击其他行的子属性的时候才会修改行备份的索引的位置
      // if (this.sIndexBak != this.sIndex) {
      //   this.sIndexBak = this.sIndex
      // }
      this.$emit('click', this.sIndex, this.lIndex)
    },
    // 列表拖拽结束时触发 2022-12-23 jws
    dragend(){
      let data = {}
      data.data = []
      for(let i = 0 ; i < this.list.length ; i++){
        if(this.list[i].value != ''){
          let list = {}
          list.typeCode = this.list[i].value
          list.typeSort = i
          data.data.push(list)
        }
      }
      console.log(data)
      this.$API['backlogSortSave'](data).then(res=>{
        console.log(res)
        if(res.code == 10000){
          this.$message({
            message: '顺序调节成功',
            duration: 2000,
            type: 'success',
          })
        }else{
          this.$message({
            message: '顺序调节失败',
            duration: 2000,
            type: 'error',
          })
        }
      })
    },
  },
}
</script>
<style lang='less'>
.displayFlex {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.h-vertical-content{
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 22px 0;
  list-style: none;
}
.h-vertical-body {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 22px 0;
  list-style: none;
  .drag-move {
    transition: transform .3s;
  }
}
.list-item {

  cursor: move;
  width: 100%;
  height: 58px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
  align-items: center;
  overflow: hidden;
  font-size: 18px;
  .list-item-superior {
    height: 58px;
    width: 100%;
    position: relative;
    .displayFlex;
    font-family: PingFang SC;
    .list-item-title {
      text-align: start;
      position: absolute;
    }
    .list-item-arrow {
      position: absolute;
      text-align: center;
      width: 20px;
    }
    & > img {
      width: 30px;
      height: 30px;
      position: absolute;
      left: 20px;
    }
  }

  .list-item-lower {
    width: 100%;
    background: #fff;
    & > div {
      .displayFlex;
      justify-content: flex-start;
      margin: 10px 20px 10px 20px;
      // padding-left: 30px;
      height: 40px;
      font-size: 16px;
      line-height: 40px;
      font-weight: 400;
      float: left;
      width: calc(100% - 40px);
      position: relative;
      .list-item-lower-arrow {
        position: absolute;
        text-align: center;
        width: 20px;
      }
      .list-item-lower-item-header {
        .displayFlex;
        justify-content: flex-end;
        width: 48px;
      }
    }
  }
}

.list-item:hover {
  background: #f2f2f2;
}

.click-event-tag {
  height: 58px;
  width: 6px;
  position: absolute;
  right: 0;
}

.list-item-lower-update {
  position: absolute;
  right: -100px;
  text-align: center;
  width: 40px;
  width: 100px;
  height: 100px;
  z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/h-vertical-list.vue